<template>
  <div class="certification-page">
    <div class="cer-box">
      <el-steps :active="active">
        <el-step title="提交认证"></el-step>
        <el-step title="扫码关注"></el-step>
        <el-step title="等待审核"></el-step>
      </el-steps>

      <div class="content-one content-view" v-if="active === 1">
        <el-row class="margin-view">
          <el-col :span="20" :offset="4" class="txt-1"
            >初次使用，请先完成招聘者认证</el-col
          >
        </el-row>
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="85px"
          class="demo-ruleForm edit"
        >
          <el-form-item label="您的姓名" prop="user_name">
            <el-input
              v-model="formData.user_name"
              placeholder="请输入姓名"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="您的性别" prop="gender">
            <el-radio-group v-model="formData.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="企业名称" prop="company_name">
            <el-input
              v-model="formData.company_name"
              placeholder="请填写和营业执照上一致的名称"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业税号" prop="tax_no">
            <el-input
              v-model="formData.tax_no"
              placeholder="请填写和营业执照上一致的代码"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="担任职位" prop="post">
            <el-input
              v-model="formData.post"
              placeholder="请填写您在企业中的职位"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="招聘电话" prop="recruit_phone">
            <el-input
              v-model="formData.recruit_phone"
              placeholder="请填写正确的招聘电话"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="招聘微信" prop="recruit_wechat">
            <el-input
              v-model="formData.recruit_wechat"
              placeholder="请填写正确的招聘微信"
              maxlength="16"
            ></el-input>
          </el-form-item>
          <el-form-item label="招聘邮箱" prop="recruit_mail">
            <el-input
              v-model="formData.recruit_mail"
              placeholder="请填写正确的招聘邮箱"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="file" ref="uploadElement">
            <el-upload
              :action="`${httpUrl}/recruitment/file/upload`"
              list-type="picture-card"
              :show-file-list="false"
              :on-success="updateSuccess"
              :on-error="updateError"
              :before-upload="beforeUpdateImg"
              :multiple="false"
              :data="{ type: 3 }"
              :headers="headerStr"
              :limit="1"
              name="file"
              class="upload-style"
              v-loading="updateLoading"
              v-if="dialogImageUrl === ''"
            >
              <i class="el-icon-plus"></i>
            </el-upload>

            <div
              class="update-img-box"
              v-if="dialogImageUrl !== ''"
              @mouseenter="updateModMc = true"
              @mouseleave="updateModMc = false"
            >
              <el-image
                class="el-img-show"
                :src="dialogImageUrl"
                fit="cover"
              ></el-image>
              <div class="mc-modal">
                <!-- v-if="updateModMc" -->
                <div class="mc-option" @click="deleteUpdateImg">
                  <span><i class="el-icon-delete"></i></span>
                  <span>删除</span>
                </div>
                <div class="mc-option" @click="seeUpdateImg">
                  <span><i class="el-icon-view"></i></span>
                  <span>查看</span>
                </div>
              </div>
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-form>
        <el-row class="margin-view">
          <el-col :span="17" :offset="4" class="btn-box">
            <el-button
              type="primary"
              class="btn-style"
              @click="submitFormRule('ruleForm')"
              >下一步</el-button
            >
          </el-col>
        </el-row>
      </div>

      <div class="content-view content-two" v-if="active === 2">
        <div class="ts-cv">
          为确保正常接收审核结果和简历投递通知<br />请使用微信扫码并关注【地产同行圈】公众号
        </div>
        <img :src="serviceInfo.qrcode_url" alt="" />
        <div class="btn-box">
          <el-button class="last-btn" @click="seeResume('less')"
            >回上一步</el-button
          >
          <el-button type="primary" class="last-btn" @click="seeResume('add')"
            >我已关注</el-button
          >
        </div>
      </div>

      <div class="content-view content-three" v-if="active === 3">
        <div class="thanks" v-if="userInfo.apply_status === 1">
          <p>正在为您审核中...</p>
          <p>预计1~3个工作日内完成审核，审核结果将通过短信通知您</p>
          <p>使用“{{ favofrites }}”快捷键，可将本网站添加至收藏，避免迷路</p>
          <p>
            如有疑问，请添加微信客服咨询：{{ serviceInfo.service_wechat_no }}
          </p>
          <!-- <el-button type="primary" class="last-btn" @click="gotoZwOption()">前往职位管理</el-button> -->
        </div>
        <div class="fail" v-if="userInfo.apply_status === 2">
          <p>抱歉，您未通过企业招聘者认证！</p>
          <p>原因：{{ userInfo.apply.reason }}</p>
          <el-button type="primary" class="last-btn" @click="refSubmit()"
            >点击重新提交认证</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapState, mapMutations, mapActions } from "vuex";

const validateUser_name = (rule, value, callback) => {
  if (value.length < 2 || value.length > 10) {
    callback(new Error("请填写正确的姓名"));
  }

  callback();
};
const validateTrim = (rule, value, callback) => {
  if (!value.trim()) {
    callback(new Error("请填写正确的姓名"));
  }
  callback();
};
const validateGender = (rule, value, callback) => {
  if (value === 2) {
    callback(new Error("请选择性别"));
  }
  callback();
};

const validateUserCard = (rule, value, callback) => {
  let reg =
    /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  if (!reg.test(value)) {
    callback(new Error("请填写正确的身份证号"));
  }
  callback();
};
const validateTax_no = (rule, value, callback) => {
  let reg = /^[0-9a-zA-Z]{1,}$/;
  if (!reg.test(value)) {
    callback(new Error("请填写正确的税号"));
  }
  callback();
};

const validateRecruit_phone = (rule, value, callback) => {
  let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(1\d{10}))$/;
  if (!reg.test(value)) {
    callback(new Error("请填写正确的招聘电话"));
  }
  callback();
};

const validateRecruit_wechat = (rule, value, callback) => {
  if (
    !/^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/.test(value) &&
    !/^(((\d{3,4}-)?[0-9]{7,8})|(1\d{10}))$/.test(value)
  ) {
    callback(new Error("请填写正确的招聘微信"));
  }
  callback();
};
const validateRecruit_mail = (rule, value, callback) => {
  let reg =
    /(?=^.{3,256}$)^([\w\-]+([\.][\w\-]+)*)@[a-zA-Z0-9][a-zA-Z0-9\-]*[\.][A-Za-z]{2,6}$/;
  if (value && !reg.test(value)) {
    callback(new Error("请填写正确的招聘邮箱"));
  }
  callback();
};

export default {
  data() {
    return {
      formData: {
        user_name: "",
        gender: 2,
        user_id_card: "",
        company_name: "",
        post: "",
        tax_no: "",
        recruit_phone: "",
        recruit_wechat: "",
        recruit_mail: "",
        file: "",
        favofrites: "Ctrl+D",
      },
      rules: {
        user_name: [
          { required: true, message: "请填写正确的姓名", trigger: "change" },
          { validator: validateUser_name, trigger: "change" },
          { validator: validateTrim, trigger: "change", message: "请填写正确的姓名" },
        ],
        gender: [
          { required: true, message: "请选择性别", trigger: "blur" },
          { validator: validateGender, trigger: "change" },
        ],
        user_id_card: [
          {
            required: true,
            message: "请填写正确的身份证号",
            trigger: "change",
          },
          { validator: validateUserCard, trigger: "change" },
        ],
        company_name: [
          {
            required: true,
            message: "请填写正确的企业名称",
            trigger: "change",
          },
          { validator: validateTrim, trigger: "change", message: "请填写正确的企业名称" },
        ],
        post: [
          { required: true, message: "请填写您当前的职位", trigger: "change" },
           { validator: validateTrim, trigger: "change", message: "请填写您当前的职位" },
        ],
        tax_no: [
          { required: true, message: "请填写正确的税号", trigger: "change" },
          { validator: validateTax_no, trigger: "change" },
        ],
        recruit_phone: [
          {
            required: true,
            message: "请填写正确的招聘电话",
            trigger: "change",
          },
          { validator: validateRecruit_phone, trigger: "change" },
        ],
        recruit_wechat: [
          {
            required: true,
            message: "请填写正确的招聘微信",
            trigger: "change",
          },
          { validator: validateRecruit_wechat, trigger: "change" },
        ],
        recruit_mail: [
          {
            required: false,
            message: "请填写正确的招聘邮箱",
            trigger: "change",
          },
          { validator: validateRecruit_mail, trigger: "change" },
        ],
        file: [{ required: true, message: "请上传企业营业执照" }],
      },
      active: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      updateLoading: false,
      updateModMc: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "serviceInfo"]),
    httpUrl() {
      return process.env.VUE_APP_API_URL;
    },
    headerStr() {
      return {
        token: Cookies.get("pc_token") || "",
        version: process.env.VUE_APP_VERSION,
      };
    },
  },
  mounted() {
    let userInfo = this.userInfo;
    if (userInfo.apply_status <= 0) {
      this.active = 1;
    } else if (userInfo.apply_status === 3) {
      this.$router.push("/");
    } else if (userInfo.apply_status === 1 && userInfo.wx_subscribe === 0) {
      this.active = 2;
    } else if (userInfo.apply_status >= 1 && userInfo.wx_subscribe === 1) {
      this.active = 3;
    }
    if (!this.formData.recruit_phone) {
      this.formData.recruit_phone = userInfo.mobile;
    }
    let version = navigator.userAgent.toLowerCase();
    let mac = version.indexOf("mac");
    let os = version.indexOf("os");
    if (mac > 0 && os > 0) {
      // 苹果系统下执行的操作
      console.log("苹果系统下执行的操作");
      this.favofrites = "Command+D";
    } else {
      // windows系统下执行的操作
      console.log("windows系统下执行的操作");
      this.favofrites = "Ctrl+D";
    }
  },
  methods: {
    ...mapMutations(["SAVA_USER_INFO"]),
    ...mapActions(["userInfoUpdate"]),
    updateError() {
      this.updateLoading = false;
    },
    updateSuccess(res) {
      this.updateLoading = false;
      if (res.code == "") {
        this.dialogImageUrl = res.data.file.url;
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    },
    beforeUpdateImg(res) {
      if (res.size > 1024 * 1024 * 5) {
        this.$fail("上传图片大小不能超过 5MB!");
        return false;
      }
      if (!["image/png", "image/jpg", "image/jpeg"].includes(res.type)) {
        this.$fail("上传图片只能是 JPG、JPEG、PNG格式!");
        return false;
      }
      this.updateLoading = true;
    },
    seeUpdateImg() {
      this.dialogVisible = true;
    },
    deleteUpdateImg() {
      this.dialogImageUrl = "";
    },
    submitFormRule(formName) {
      this.rules.file = [{ required: true, message: "请上传企业营业执照" }];
      if (this.dialogImageUrl) {
        this.rules.file = [];
        this.$refs["uploadElement"].clearValidate();
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.active++;
        } else {
          this.$message({
            type: "error",
            message: "验证失败，请重新填写",
          });
          this.loading = false;
          return false;
        }
      });
    },
    seeResume(tag) {
      if (tag === "less") {
        this.active--;
        return false;
      }
      this.userInfoUpdate().then((res) => {
        if (res.wx_subscribe === 0) {
          this.$fail("未获取到公众号关注信息，再试试吧~");
        } else {
          this.submitQyInfo();
        }
      });
    },
    refSubmit() {
      this.active = 1;
    },
    submitQyInfo() {
      let self = this;
      self.$axios
        .post("/recruitment/user/userApply", {
          ...self.formData,
          company_license: self.dialogImageUrl,
        })
        .then((res) => {
          this.active++;
          this.SAVA_USER_INFO(res.data);
        });
    },
    gotoZwOption() {
      this.$router.push("/Management/staff");
    },
  },
};
</script>

<style lang='scss'>
@import "$styles/global.scss";

.certification-page {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 40px;
  @include flex-box(center, flex-start);
  @include scroll-style();

  .cer-box {
    width: 500px;

    .content-view {
      width: 100%;
      margin-top: 65px;
    }

    .content-one {
      width: 100%;
      margin-top: 65px;
      .margin-view {
        margin-top: 21px;

        .box-center {
          @include flex-box(flex-start);
          height: 40px;
        }

        .name-v {
          text-align: center;
          font-size: 14px;
          line-height: 40px;
          color: #606266;
        }

        .upload-style {
          width: 148px;
          height: 148px;
          overflow: hidden;
        }

        .update-img-box {
          width: 148px;
          height: 148px;
          border-radius: 6px;
          overflow: hidden;
          border: 1px dashed #c0ccda;
          position: relative;

          .el-img-show {
            width: 100%;
            height: 100%;
          }

          .mc-modal {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            @include flex-box(space-around);
            background-color: rgba($color: #fff, $alpha: 0.8);
            .mc-option {
              color: $main-color;
              text-align: center;
              font-size: 14px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
      .mc-modal,
      .mc-option {
        display: flex;
      }
      .mc-option {
        margin-right: 10px;
        cursor: pointer;
      }
      .txt-1 {
        font-size: 22px;
        margin-bottom: 20px;
      }

      .btn-box {
        padding-top: 20px;

        .btn-style {
          width: 100%;
        }
      }
    }

    .content-two {
      @include flex-box();

      .ts-cv {
        width: 100%;
        font-size: 22px;
        line-height: 30px;
        text-align: center;
      }

      img {
        width: 270px;
        height: 270px;
        margin-top: 60px;
      }

      .btn-box {
        margin-top: 90px;
        width: 100%;
        @include flex-box();

        .last-btn {
          width: 166px;
        }
      }
    }

    .content-three {
      margin-top: 140px;

      .thanks {
        @include flex-box(center, flex-start);

        p {
          width: 100%;
          text-align: center;
        }

        p:nth-child(1) {
          font-size: 36px;
        }

        p:nth-child(2) {
          margin-top: 80px;
          font-size: 18px;
          line-height: 28px;
          color: $last-color;
        }

        .last-btn {
          margin-top: 40px;
        }
      }

      .fail {
        @include flex-box();
        width: 100%;

        p {
          width: 100%;
          text-align: center;
        }

        p:nth-child(1) {
          white-space: nowrap;
          font-size: 36px;
        }

        p:nth-child(2) {
          font-size: 18px;
          color: $last-color;
          margin: 60px 0 80px 0;
        }
      }
    }
  }
}
</style>
